import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import Accordion from "@mui/material/Accordion";
import VoyageAccordion from "../ui/VoyageAccordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Label } from "abs-ui-components";
import { Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";
const OtherFuels = ({ section, type, expandedId, setExpandedId }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const accordionRef2 = useRef(null);

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};

	const handleAccordionFocus = (event, accordionReference) => {
		if (
			accordionReference.current &&
			event.target === accordionReference.current
		) {
			// Simulate a click to toggle the accordion
			accordionReference.current.click();
		}
	};
	return (
		<>
			{section.sectionName === "OtherFuel Details" && (
				<VoyageAccordion
					accordionId="OTHER_FUELS"
					expandedId={expandedId}
					setExpandedId={setExpandedId}
					className="mt-4"
					onKeyDown={(event) => {
						if (event.key === "Tab") {
							handleAccordionFocus(event, accordionRef2);
						}
					}}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
						ref={accordionRef2}
					>
						<span className="voyage-form-headings">
							OTHER FUEL DETAILS
						</span>
					</AccordionSummary>
					<AccordionDetails>
						<MDBRow className="mt-0">
							{/* Group fields by subSection */}
							{Object.entries(
								section?.fields?.reduce((acc, formField) => {
									const subSection = formField.subSection;
									if (!acc[subSection]) {
										acc[subSection] = []; // Initialize a new subsection
									}
									acc[subSection].push(formField); // Add field to the corresponding subSection
									return acc;
								}, {})
							).map(([subSection, fields], idx) => (
								<div key={subSection} className="pl-3">
									{/* Render Subsection Title */}
									<MDBRow className="">
										<span className="ml-3 voyage-form-sub-headings">
											{subSection}
										</span>
									</MDBRow>
									<MDBRow className="mt-0">
										{fields.map((formField, fieldIndex) => (
											<MDBCol
												md="3"
												className="pr-2 mt-2 mb-4"
												key={`${formField.key}-${fieldIndex}`}
											>
												{formField.dataType ===
													"decimal" && (
														<>
															<Label
																bold
																name={
																	formField.fieldName
																}
																className="mb-1"
															/>
															<Controller
																name={
																	sanitizeKey(formField.key)
																}
																control={control}
																defaultValue={
																	type === "Edit"
																		? formField.value ||
																		null
																		: ""
																}
																render={({
																	field,
																}) => {
																	// Ensure field is defined before accessing properties
																	if (!field)
																		return null; // Return null if field is undefined

																	return (
																		<Input
																			autoFocus={
																				false
																			}
																			{...field} // Spread the field props from Controller
																			className="inputHeight"
																			type="number"
																			step="any"
																			onChange={(
																				e
																			) =>
																				field.onChange(
																					e
																				)
																			}
																			value={
																				field?.value ??
																				""
																			} // Safely use field.value or fallback to ''
																			onKeyDown={(e) => {
																				preventScientificNotation(e);
																				// Prevent up and down arrow keys
																				if (
																					e.key === "ArrowUp" ||
																					e.key === "ArrowDown"
																				) {
																					e.preventDefault();
																				}
																			}}
																			onWheel={(e) => e.target.blur()}
																		/>
																	);
																}}
															/>
														</>
													)}
											</MDBCol>
										))}
									</MDBRow>
								</div>
							))}
						</MDBRow>
					</AccordionDetails>
				/</VoyageAccordion>
			)}
		</>
	);
};

export default OtherFuels;
